import { Configuration, MeasurementMaintenanceApi, MeasurementPointcloudViewApi, MeasurementViewApi } from '@rhim/rest/measurementService';

const BASE_URL = '/api/measurementservice/v1';

const configuration: Configuration = {} as Configuration;

export const measurementView = new MeasurementViewApi(configuration, BASE_URL);
export const measurementPointcloudView = new MeasurementPointcloudViewApi(configuration, BASE_URL);
export const measurementMaintenance = new MeasurementMaintenanceApi(configuration, BASE_URL);
